import {useCallback} from 'react'

export const usePrintLicense = () => {
  const print = useCallback((application: string) => {
    const printWindow = window.open(
      `/mcc-portal-ui/apps/license-info/${application}/print`,
      '_blank',
      'popup=true,scrollbars=false'
    )
    if (!printWindow) {
      throw 'failed to open window for printing license'
    }
    printWindow.onafterprint = () => printWindow.close()
    printWindow.onload = () => {
      printWindow.document.title = `${application.toLowerCase()}_license_certificate`
    }
  }, [])
  return print
}